document.addEventListener("DOMContentLoaded", function(){

  const modal = document.querySelector(".featured-product-modal");
  const modalImage = document.getElementById("modal-product-image");
  const modalTitle = document.getElementById("modal-product-title");
  const modalPrice = document.getElementById("modal-product-price");
  const formContainer = document.getElementById("modal-product-form-container");
  const closeBtn = document.querySelector(".modal-close");
  const modalColor = document.getElementById("modal-product-color");
  const modalTagline = document.getElementById("modal-tagline");

  let modalProducts = [];
  let currentProductIndex = 0;
  let currentProductImages = [];
  let currentImageIndex = 0;


  /* ===============================
  PRODUCT LOADER
  =============================== */

function loadProduct(index){

  const product = modalProducts[index];
  if(!product) return;

  const title = product.dataset.title;
  const image = product.dataset.image;
  const price = product.dataset.price;
  const color = product.dataset.color;
  const tag = product.dataset.tag;

  // Parse product images array
  try {
    currentProductImages = JSON.parse(product.dataset.images || '[]');
  } catch(e) {
    currentProductImages = [image];
  }
  
  // If no images found, use the main image
  if(currentProductImages.length === 0) {
    currentProductImages = [image];
  }
  
  // Reset image index to first image
  currentImageIndex = 0;

  modalTitle.innerHTML = title || "";
  modalImage.src = currentProductImages[0] || image || "";
  modalPrice.textContent = price || "";
  modalColor.textContent = color || "";
  if(modalTagline){
    if(tag && tag.trim() !== ""){
        modalTagline.textContent = tag;
        modalTagline.style.display = "inline-block";
    }else{
        modalTagline.style.display = "none";
    }
    }

  /* ===============================
  SWATCH VISIBILITY
  =============================== */

  const switcher = modal.querySelector(".modal-product-switcher");

  if(switcher){

    const hideSwatch = product.dataset.swatchHide === "true";

    if(hideSwatch){
      switcher.classList.add("hide-swatch");
    }else{
      switcher.classList.remove("hide-swatch");
    }

    /* ===============================
    PRODUCT IMAGE SWITCHER
    =============================== */

    switcher.innerHTML = "";

    modalProducts.forEach(function(p, i){

      const btn = document.createElement("button");
      btn.className = "modal-product-tab";

      btn.innerHTML = `<img src="${p.dataset.swatch}" width="60">`;

      if(i === index){
        btn.classList.add("active");
      }

      btn.addEventListener("click", function(){

        currentProductIndex = i;
        loadProduct(currentProductIndex);

      });

      switcher.appendChild(btn);

    });

  }

  /* ===============================
  LOAD FORM
  =============================== */

  const template = product.querySelector(".modal-product-form-template");

  if(template && formContainer){

    formContainer.innerHTML = "";

    const clone = template.firstElementChild.cloneNode(true);
    formContainer.appendChild(clone);

    const form = formContainer.querySelector('[data-product-form]');
    if(!form) return;

    const select = form.querySelector('[data-variant-select]');
    const hiddenInput = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-atc-button]');

    if(select){

      const cleanSelect = select.cloneNode(true);
      select.parentNode.replaceChild(cleanSelect, select);

      cleanSelect.addEventListener("change", function(){

        const selectedOption = cleanSelect.options[cleanSelect.selectedIndex];
        const variantId = selectedOption.value;
        const isAvailable = selectedOption.dataset.available === "true";

        if(!variantId){
          button.textContent = "Add to Cart";
          button.disabled = true;
          hiddenInput.value = "";
          return;
        }

        hiddenInput.value = variantId;

        if(isAvailable){
          button.textContent = "Add to Cart";
          button.disabled = false;
        }else{
          button.textContent = "Sold Out";
          button.disabled = true;
        }

      });

      cleanSelect.dispatchEvent(new Event("change"));

    }

  }

}


  /* ===============================
  OPEN MODAL
  =============================== */

  document.addEventListener("click", function(e){

    const trigger = e.target.closest(".featured-product-tooltip, .featured-product-tooltip-overlay");
    if(!trigger) return;

    const card = trigger.closest(".featured-product-cards__card");
    if(!card) return;

    modalProducts = Array.from(card.querySelectorAll(".modal-product"));

    if(!modalProducts.length) return;

    currentProductIndex = 0;

    loadProduct(currentProductIndex);

    modal.classList.add("open");

  });


  /* ===============================
  ARROW SWITCHING (Image Gallery)
  =============================== */

  document.addEventListener("click", function(e){

    if(e.target.closest(".modal-product-next")){

      if(currentProductImages.length <= 1) return;

      currentImageIndex++;

      if(currentImageIndex >= currentProductImages.length){
        currentImageIndex = 0;
      }

      modalImage.src = currentProductImages[currentImageIndex];
    }

    if(e.target.closest(".modal-product-prev")){

      if(currentProductImages.length <= 1) return;

      currentImageIndex--;

      if(currentImageIndex < 0){
        currentImageIndex = currentProductImages.length - 1;
      }

      modalImage.src = currentProductImages[currentImageIndex];
    }

  });


  /* ===============================
  CLOSE MODAL
  =============================== */

  if(closeBtn){
    closeBtn.addEventListener("click", function(){
      modal.classList.remove("open");
    });
  }


  /* ===============================
  ADD TO CART
  =============================== */

  document.addEventListener("submit", async function(e){

    const form = e.target.closest("[data-product-form]");
    if(!form) return;

    e.preventDefault();

    const variantInput = form.querySelector("[data-variant-id]");
    const button = form.querySelector("[data-atc-button]");

    if(!variantInput || !variantInput.value) return;

    const variantId = variantInput.value;

    button.disabled = true;
    button.textContent = "Adding…";

    try{

      const response = await fetch("/cart/add.js",{
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          "Accept":"application/json"
        },
        body:JSON.stringify({
          id:variantId,
          quantity:1
        })
      });

      if(!response.ok){
        throw new Error("Add to cart failed");
      }

      await response.json();

      modal.classList.remove("open");

      document.dispatchEvent(
        new CustomEvent("cart:refresh",{bubbles:true})
      );

      const cartDrawer =
        document.querySelector("cart-drawer") ||
        document.querySelector(".cart-drawer");

      if(cartDrawer){
        cartDrawer.classList.add("active");
      }

    }catch(error){

      console.error("Cart error:", error);

      button.textContent = "Error";
      button.disabled = false;

    }

  });

});